import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";

import { reloadOnceOnJsChunkError } from "./reloadOnceOnJsChunkError";

import { wrapRouterMethod } from "./safeNavigation";


Vue.use(Router);

const router = new Router({
  mode: "history",
  routes,
});

// Falhas esperadas do vue-router (duplicated/cancelled/aborted/redirected)
// são engolidas no wrapper; erros reais (ex.: TypeError) continuam rejeitando.
const originalPush = router.push.bind(router);
const originalReplace = router.replace.bind(router);

router.push = wrapRouterMethod(originalPush, "push");
router.replace = wrapRouterMethod(originalReplace, "replace");

router.onError((err) => {
  reloadOnceOnJsChunkError(err);
});

export default router;
